import extractText from 'flarum/common/utils/extractText';
export class TicketTypeRegistry {
  drivers = (() => new Map())();
  register(driver) {
    this.drivers.set(driver.id, driver);
  }
  get(id) {
    return this.drivers.get(id);
  }

  /**
   * The driver for a category's ticket type, if one is registered on the
   * client. Categories without a type are standard.
   */
  forCategory(category) {
    if (!category) return undefined;
    const id = category.ticketType && category.ticketType() || 'standard';
    return this.drivers.get(id);
  }
  has(id) {
    return this.drivers.has(id);
  }
  all() {
    return Array.from(this.drivers.values());
  }
}
export const ticketTypes = new TicketTypeRegistry();

// Register built-in ticket types as living examples for other extensions
ticketTypes.register({
  id: 'standard',
  name: () => extractText(app.translator.trans('linkrobins-support.admin.ticket_types.standard'))
});
ticketTypes.register({
  id: 'appeal',
  name: () => extractText(app.translator.trans('linkrobins-support.admin.ticket_types.appeal'))
});
export default ticketTypes;
flarum.reg.add('linkrobins-support', 'common/ticketTypes', ticketTypes);